"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "banners", {
  enumerable: true,
  get: function get() {
    return _banners["default"];
  }
});
var _banners = _interopRequireDefault(require("./banners"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }